<template>
    <div class="emp-card" :key="`emp-${employeeId}`">
        <DxDataGrid :data-source="dsCentre" ref="dataGridRef" :allow-column-reordering="true"
            :allow-column-resizing="true" :column-auto-width="false" :show-borders="true" key-expr="Id"
            @row-dbl-click="onRowDblClick">
            <DxSelection mode="single" />
            <DxFilterRow :visible="false" />
            <DxPaging :page-size="10" :page-index="0" />
            <DxLoadPanel :enabled="true" :indicator-src="'reload6.gif'" />
            <DxSorting mode="multiple" />
            <DxScrolling mode="standard" :show-scrollbar="'always'" />
            <DxColumnFixing :enabled="true" />
            <DxEditing :allow-updating="true" :allow-deleting="true" mode="popup">
                <DxPopup :closeOnOutsideClick="false" :showCloseButton="false" :width="700" :height="380"
                    :show-title="false">
                    <DxToolbarItem :template="customTitleTemplate" />
                    <DxToolbarItem toolbar="bottom" widget="dxButton" location="after" :options="saveButtonOptions" />
                    <DxToolbarItem toolbar="bottom" widget="dxButton" location="after" :options="dangerButtonOptions" />
                </DxPopup>
                <DxFormGrid :col-count="2">
                    <DxItem data-field="CapitolId" :label="{ text: 'Centru de cost' }" :col-span="2" />
                    <DxItem data-field="ProcentDinTotal" :label="{ text: '% Alocat' }" editor-type="dxNumberBox" />
                    <DxItem data-field="ContId" :label="{ text: 'Cont contabil' }" :col-span="2" />
                </DxFormGrid>
            </DxEditing>

            <DxColumn data-field="CapitolId" caption="Centru de cost" width="300">
                <DxLookup :data-source="dsCapitoleLookup" value-expr="Id" :display-expr="capitolDisplay"
                    :search-enabled="true" />
            </DxColumn>
            <DxColumn data-field="ProcentDinTotal" caption="% Alocat" width="120" />
            <DxColumn data-field="ContId" caption="Cont contabil" width="300">
                <DxLookup :data-source="dsConturiLookup" value-expr="Id" :display-expr="contDisplay"
                    :search-enabled="true" />
            </DxColumn>

            <DxToolbar>
                <DxItem>
                    <template #default>
                        <DxButton icon="add" type="success" @click="onAddClick" />
                    </template>
                </DxItem>
            </DxToolbar>
        </DxDataGrid>
        <DxPopupAdd :visible="addPopupVisible" :show-title="true" :height="380" :width="700">
            <template #title>
                <div
                    style="background-color: #ff2c21; font-size: 15px; color: white; font-weight: bold;  padding: 10px; padding-left: 20px; ">
                    Adăugare Centru de cost
                </div>
            </template>
            <DxForm :col-count="2" :form-data="formData" label-alignment="left">
                <DxSimpleItem data-field="CapitolId" :label="{ text: 'Centru de cost' }" :col-span="2"
                    editor-type="dxSelectBox" :editor-options="{
                        dataSource: dsCapitoleLookup,
                        valueExpr: 'Id',
                        displayExpr: capitolDisplay,
                        searchEnabled: true,
                        showClearButton: true,
                        placeholder: 'Selectează'
                    }" />
                <DxSimpleItem data-field="ProcentDinTotal" :label="{ text: '% Alocat' }" editor-type="dxNumberBox" />
                <DxSimpleItem data-field="ContId" :label="{ text: 'Cont contabil' }" :col-span="2"
                    editor-type="dxSelectBox" :editor-options="{
                        dataSource: dsConturiLookup,
                        valueExpr: 'Id',
                        displayExpr: contDisplay,
                        searchEnabled: true,
                        showClearButton: true,
                        placeholder: 'Selectează'
                    }" />
            </DxForm>
            <DxToolbarItem widget="dxButton" toolbar="bottom" location="after" :options="addButtonOptions" />
            <DxToolbarItem widget="dxButton" toolbar="bottom" location="after" :options="closeButtonOptions" />
        </DxPopupAdd>
    </div>
</template>
<script lang="ts">
import {
    DxColumn,
    DxDataGrid,
    DxFilterRow,
    DxLoadPanel,
    DxLookup,
    DxPaging,
    DxSelection,
    DxSorting,
    DxToolbar,
    DxEditing,
    DxPopup,
    DxItem,
    DxItem as DxFormItem,
    DxForm as DxFormGrid,
    DxScrolling,
    DxColumnFixing
} from 'devextreme-vue/data-grid';
import ODataStore from 'devextreme/data/odata/store';
import AppSetting from '@/settings/appSettings';
import { defineComponent, ref } from 'vue';
import DataSource from 'devextreme/data/data_source';
import { DxButton } from 'devextreme-vue/button';
import notify from 'devextreme/ui/notify';
import { DxForm, DxSimpleItem } from "devextreme-vue/form"
import DxPopupAdd from 'devextreme-vue/popup'
import { DxToolbarItem } from 'devextreme-vue/popup';

export default defineComponent({
    components: {
        DxColumn, DxDataGrid, DxFilterRow, DxLoadPanel, DxLookup, DxPaging, DxSelection, DxSorting,
        DxToolbar, DxEditing, DxItem, DxButton, DxForm, DxPopupAdd, DxSimpleItem,
        DxToolbarItem, DxPopup, DxFormGrid, DxFormItem, DxScrolling, DxColumnFixing
    },
    props: {
        employeeId: { type: String, required: true },
        employeeRow: { type: Object, default: null }
    },
    watch: {
        employeeId: {
            immediate: true,
            handler(id) {
                if (!id || !this.$refs.dataGridRef?.instance) return;
                const ds = this.$refs.dataGridRef.instance.getDataSource();
                ds.filter(["AngajatId", "=", id]);
                ds.load();
            }
        }
    },
    data() {
        return {
            dsCentre: {} as DataSource,
            dsCapitoleLookup: {
                store: new ODataStore({
                    url: AppSetting.API_Url_ResurseUmaneOdata + "DOC_Capitole",
                    key: "Id",
                    beforeSend: e => {
                        e.headers = { Authorization: "Bearer " + localStorage.getItem("ERA_Jwt") };
                    }
                }),
                paginate: true,
                pageSize: 50,
                searchExpr: ["Nume", "Cod"]
            } as any,
            dsConturiLookup: {
                store: new ODataStore({
                    url: AppSetting.API_Url_ResurseUmaneOdata + "CON_Conturi",
                    key: "Id",
                    beforeSend: e => {
                        e.headers = { Authorization: "Bearer " + localStorage.getItem("ERA_Jwt") };
                    }
                }),
                paginate: true,
                pageSize: 50,
                searchExpr: ["Simbol", "Nume"]
            } as any,
            dataGridRef: ref<DxDataGrid | null>(null),
            addPopupVisible: false,
            formData: {
                Id: null,
                AngajatId: null,
                CapitolId: null,
                ProcentDinTotal: null,
                ContId: null
            } as any,
            addButtonOptions: {
                type: "success", text: "Salvează", stylingMode: "contained",
                onClick: () => { this.onSaveAdd() }
            },
            saveButtonOptions: {
                type: "success", text: "Salvează", stylingMode: "contained",
                onClick: () => { this.onSaveEdit() }
            },
            closeButtonOptions: {
                type: "danger", text: "Închide", stylingMode: "contained",
                onClick: () => { this.onCloseAdd() }
            },
            dangerButtonOptions: {
                type: "danger", text: "Închide", stylingMode: "contained",
                onClick: () => { this.closeEditPopup() }
            },
            customTitleTemplate() {
                return `
        <div style="background-color: #ff2c21; font-size: 16px; float: right; height:47px; width:880px; color: white;
        font-weight: bold;  padding: 12px; padding-right: 450px;  position: relative;  left: 30px;">
          Editare
        </div>`;
            },
        }
    },
    mounted() {
        this.dsCentre = new DataSource({
            store: new ODataStore({
                version: 4,
                url: AppSetting.API_Url_ResurseUmaneOdata + "SAL_CapitoleConfig",
                key: "Id",
                fieldTypes: { Id: "Guid", AngajatId: "Guid", CapitolId: "Guid", ContId: "Guid" },
                beforeSend: e => {
                    e.headers = { Authorization: "Bearer " + localStorage.getItem("ERA_Jwt") };
                }
            }),
            filter: ["AngajatId", "=", this.employeeId]
        });
    },
    methods: {
        capitolDisplay(item: any) {
            if (!item) return '';
            return [item.Cod, item.Nume].filter(Boolean).join(' - ');
        },
        contDisplay(item: any) {
            if (!item) return '';
            return [item.Simbol, item.Nume].filter(Boolean).join(' - ');
        },
        onRowDblClick(e: any) {
            if (e?.rowType === 'data' && e?.component) e.component.editRow(e.rowIndex);
        },
        closeEditPopup() {
            this.dataGridRef?.instance?.cancelEditData();
        },
        onAddClick() {
            this.formData = { Id: null, AngajatId: this.employeeId, CapitolId: null, ProcentDinTotal: null, ContId: null };
            this.addPopupVisible = true;
        },
        async onSaveEdit() {
            const gridInstance = this.dataGridRef?.instance;
            if (!gridInstance) { notify('Eroare: Grila nu este încărcată.', 'error', 2000); return; }
            try {
                await gridInstance.saveEditData();
                notify('Datele au fost salvate cu succes!', 'success', 2000);
            } catch (error: any) {
                console.error(error);
                notify('Eroare la salvarea editării!', 'error', 2000);
            }
        },
        onSaveAdd() {
            if (!this.formData.CapitolId) { notify('Selectați "Centru de cost"!', 'error', 2000); return; }
            const payload = { ...this.formData, Id: crypto.randomUUID(), AngajatId: this.employeeId };
            const store = (this.dsCentre as DataSource).store();
            store.insert(payload).then(() => {
                this.addPopupVisible = false;
                notify('Datele au fost salvate cu succes!', 'success', 2000);
                this.onCloseAdd();
                this.dataGridRef?.instance?.refresh();
            }).catch((error: any) => {
                console.error(error);
                notify('Eroare la salvarea datelor!', 'error', 2000);
            });
        },
        onCloseAdd() {
            this.addPopupVisible = false;
            this.formData = { Id: null, AngajatId: this.employeeId, CapitolId: null, ProcentDinTotal: null, ContId: null };
        },
    },
})
</script>
